import { cn } from "@/lib/utils";

type CheckoutRedirectOverlayProps = {
  open: boolean;
  /** "stripe" | "mercadopago" — copy del redirect. */
  gateway?: "stripe" | "mercadopago";
  /** Idioma corto para mensajes (es | en). */
  language?: "es" | "en";
  className?: string;
};

const COPY = {
  es: {
    stripe: {
      title: "Preparando tu pago",
      subtitle: "Te llevamos a Stripe en un momento…",
    },
    mercadopago: {
      title: "Preparando tu pago",
      subtitle: "Te llevamos a Mercado Pago en un momento…",
    },
  },
  en: {
    stripe: {
      title: "Preparing checkout",
      subtitle: "Redirecting you to Stripe…",
    },
    mercadopago: {
      title: "Preparing checkout",
      subtitle: "Redirecting you to Mercado Pago…",
    },
  },
} as const;

/**
 * Overlay fullscreen mientras se crea la sesión y antes del redirect al gateway.
 * Evita double-tap y comunica que el pago sigue en curso.
 */
export function CheckoutRedirectOverlay({
  open,
  gateway = "stripe",
  language = "en",
  className,
}: CheckoutRedirectOverlayProps) {
  if (!open) return null;

  const lang = language === "es" ? "es" : "en";
  const text = COPY[lang][gateway];

  return (
    <div
      className={cn(
        "fixed inset-0 z-[200] flex items-center justify-center bg-black/75 backdrop-blur-sm",
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-5 px-8 text-center">
        <div className="relative h-14 w-14">
          <div className="absolute inset-0 rounded-full border-2 border-white/15" />
          <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-amber-400 animate-spin" />
        </div>
        <div className="space-y-1.5">
          <p className="text-[15px] font-semibold tracking-tight text-white">{text.title}</p>
          <p className="text-[13px] text-white/60">{text.subtitle}</p>
        </div>
      </div>
    </div>
  );
}